import React from 'react';
import { Row, Col, Card, CardTitle } from 'reactstrap';
import { useFormikContext } from 'formik';
import { Field } from '@availity/form';
import { SelectField } from '@availity/select';
import { SwitchButton } from '@/components';

const mlVersionOptions = [
  { value: 'V2', label: 'V2' },
  { value: 'V3', label: 'V3' },
];

const MLSettingsCard: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<{
    allowMLearning: boolean;
    allowMLOnSubmit: boolean;
    mlVersion: any;
    useEventsMLModel: boolean;
    allowMLPriceOverride: boolean;
    minAcceptenceBid: number;
    mlTargetMaxPrice: number;
    mlTargetMinPrice: number;
    mlTargetConversionRate: number;
    mlProbablityIncreasePercentage: number;
    mlProbablityIncreasePerLead: number;
    mlAggressionConversionLevel: number;
    mlAggressionPriceLevel: number;
    mlBeforeThreashold: boolean;
    allowAdvanceFitering: boolean;
    doNotAcceptQualityRejects: boolean;
    allowMLOverride: boolean;
    mlNetworkOptimized: boolean;
    mlCPATarget: number;
  }>();

  return (
    <>
      <Card body className="mt-3">
        <Row>
          <Col xs={2}>
            <CardTitle tag="h4" className="lead text-uppercase">
              Allow ML
            </CardTitle>
            <SwitchButton
              width={100}
              checked={!!values.allowMLearning}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue('allowMLearning', !values.allowMLearning)
              }
            />
          </Col>
          <Col xs={2} className="ml-4">
            <SelectField
              id="attribute-ml-version"
              name="mlVersion"
              options={mlVersionOptions}
              label="ML Version"
              onChange={(val: any) => {
                setFieldValue('mlVersion', val);
              }}
              raw
            />
          </Col>
        </Row>
        <Row className="mt-3">
          {/* <Col xs={4}>
            <CardTitle tag="h4" className="lead text-uppercase">
              Use Events ML Model
            </CardTitle>
            <div id="switch-button-1">
              <SwitchButton
                width={100}
                checked={!!values.useEventsMLModel}
                onlabel="Enabled"
                offlabel="Disabled"
                onstyle="success"
                offstyle="danger"
                onChange={() =>
                  setFieldValue('useEventsMLModel', !values.useEventsMLModel)
                }
              />
            </div>
          </Col> */}
          <Col xs={4}>
            <CardTitle tag="h4" className="lead text-uppercase">
              ML Price Override
            </CardTitle>
            <div id="switch-button-2">
              <SwitchButton
                width={100}
                checked={!!values.allowMLPriceOverride}
                onlabel="Enabled"
                offlabel="Disabled"
                onstyle="success"
                offstyle="danger"
                onChange={() =>
                  setFieldValue(
                    'allowMLPriceOverride',
                    !values.allowMLPriceOverride
                  )
                }
              />
            </div>
          </Col>
          <Col xs={3}>
            <CardTitle tag="h4" className="lead text-uppercase">
              Allow ML On Submit
            </CardTitle>
            <SwitchButton
              width={100}
              checked={!!values.allowMLOnSubmit}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue('allowMLOnSubmit', !values.allowMLOnSubmit)
              }
            />
          </Col>
          <Row className="mt-3 ml-1">
            <Col xs={3}>
              <Field
                id="ml-target-min-price"
                name="mlTargetMinPrice"
                label="Target Price Min"
                type="number"
                min={0}
                step="0.01"
                onBlur={({ target: { value } }) => {
                  setFieldValue('mlTargetMinPrice', parseFloat(value, 0));
                }}
                helpMessage="Set the target min price"
              />
            </Col>
            <Col xs={3}>
              <Field
                id="ml-target-max-price"
                name="mlTargetMaxPrice"
                label="Target Price Max"
                type="number"
                min={0}
                step="0.01"
                onBlur={({ target: { value } }) => {
                  setFieldValue('mlTargetMaxPrice', parseFloat(value, 0));
                }}
                helpMessage="Set the target max price"
              />
            </Col>
            <Col xs={3}>
              <Field
                id="ml-target-max-price"
                name="minAcceptenceBid"
                label="Min Accepted Bid"
                type="number"
                min={0}
                step="0.01"
                onBlur={({ target: { value } }) => {
                  setFieldValue('minAcceptenceBid', parseFloat(value, 0));
                }}
                helpMessage="Set the min accepted price"
              />
            </Col>
            <Col xs={3}>
              <Field
                id="ml-target-conversion-rate"
                name="mlTargetConversionRate"
                label="Target Conversion Rate"
                type="number"
                min={0}
                step="any"
                onBlur={({ target: { value } }) => {
                  setFieldValue('mlTargetConversionRate', parseFloat(value));
                }}
                helpMessage="Set the target conversion rate on the lead"
              />
            </Col>
          </Row>
          {values.mlVersion?.value === 'V3' ? (
            <Row className="ml-1">
              {/* <Col xs={6}>
                Network Optimized
                <p />
                <SwitchButton
                  width={100}
                  checked={!!values.mlNetworkOptimized}
                  onlabel="Enabled"
                  offlabel="Disabled"
                  onstyle="success"
                  offstyle="danger"
                  onChange={() =>
                    setFieldValue(
                      'mlNetworkOptimized',
                      !values.mlNetworkOptimized
                    )
                  }
                /> */}

              <Col xs={6}>
                <Field
                  id="ml-cpt-target"
                  name="mlCPATarget"
                  label="CPA Target"
                  type="number"
                  min={1}
                  max={1000}
                  step="0"
                  onBlur={({ target: { value } }) => {
                    setFieldValue('mlCPATarget', parseInt(value, 0));
                  }}
                  helpMessage="Controls Bid Levels (Default: Ex: 300, Shr: 200)"
                />
              </Col>
            </Row>
          ) : null}
          {values.mlVersion?.value === 'V2' ? (
            <Row className="ml-1">
              <Col xs={6}>
                <Field
                  id="ml-agg-price"
                  name="mlAggressionPriceLevel"
                  label="Price Aggression"
                  type="number"
                  min={0}
                  max={1}
                  step="0"
                  onBlur={({ target: { value } }) => {
                    setFieldValue('mlAggressionPriceLevel', parseInt(value, 0));
                  }}
                  helpMessage="Set aggression price level"
                />
              </Col>
              <Col xs={6}>
                <Field
                  id="ml-agg-conv"
                  name="mlAggressionConversionLevel"
                  label="Conversion Aggression"
                  type="number"
                  min={0}
                  max={1}
                  step="0"
                  onBlur={({ target: { value } }) => {
                    setFieldValue(
                      'mlAggressionConversionLevel',
                      parseInt(value, 0)
                    );
                  }}
                  helpMessage="Set aggression conversation level"
                />
              </Col>
            </Row>
          ) : null}
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          AI Quality Filtering
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            AI Quality Monitoring
            <p />
            <SwitchButton
              width={100}
              checked={!!values.allowAdvanceFitering}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'allowAdvanceFitering',
                  !values.allowAdvanceFitering
                )
              }
            />
          </Col>
          <Col xs={2}>
            Reject Bad Quality
            <p />
            <SwitchButton
              width={100}
              checked={!!values.doNotAcceptQualityRejects}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'doNotAcceptQualityRejects',
                  !values.doNotAcceptQualityRejects
                )
              }
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3 mb-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          ML Active Demand Settings
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Before Active Demand Threashold
            <SwitchButton
              width={100}
              checked={!!values.mlBeforeThreashold}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue('mlBeforeThreashold', !values.mlBeforeThreashold)
              }
            />
          </Col>
          <Col xs={3}>
            <Field
              id="ml-probablity-increase-percentage"
              name="mlProbablityIncreasePercentage"
              label="ML Probablity Increase Percentage"
              type="number"
              min={0}
              step="0.01"
              onBlur={({ target: { value } }) => {
                setFieldValue(
                  'mlProbablityIncreasePercentage',
                  parseFloat(value, 0)
                );
              }}
              helpMessage="Set incremental ML Probablity Increase Percentage"
            />
          </Col>
          <Col xs={3}>
            <Field
              id="ml-probablity-increase-perlead"
              name="mlProbablityIncreasePerLead"
              label="ML Probablity Increase Per Lead"
              type="number"
              min={0}
              step="1"
              onBlur={({ target: { value } }) => {
                setFieldValue(
                  'mlProbablityIncreasePerLead',
                  parseInt(value, 0)
                );
              }}
              helpMessage="Set count of leads backloged to trigger the ML Probablity Increase Per Lead"
            />
          </Col>
        </Row>
      </Card>
      {/* <Card body className="mt-3 mb-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          ML Override Rejects
        </CardTitle>
        <Row>
          <Col xs={2} className="mt-3">
            <SwitchButton
              width={100}
              checked={!!values.allowMLOverride}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue('allowMLOverride', !values.allowMLOverride)
              }
            />
          </Col>
        </Row>
      </Card> */}
    </>
  );
};

export default MLSettingsCard;
